// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s2QKE","input":"styles_input__2HI_t"};